import React from 'react';
import ContentLoader from 'react-content-loader';

export default function MyPageLoader() {
  return (
    <div style={{borderBottom: '1px solid #E9E7EC'}}>
      <ContentLoader
        speed={2}
        width={380}
        height={404}
        viewBox="0 0 380 404"
        backgroundColor="#F5F5F5"
        foregroundColor="#EFEFEF"
        style={{width: '100%'}}>
        <rect x="20" y="20" rx="60" ry="60" width="60" height="60" />
        <rect x="20" y="100" rx="0" ry="0" width="178" height="32" />
        <rect x="20" y="142" rx="0" ry="0" width="335" height="20" />
        <rect x="20" y="196" rx="0" ry="0" width="335" height="103" />
        <rect x="20" y="309" rx="0" ry="0" width="335" height="65" />
      </ContentLoader>
      <ContentLoader
        speed={2}
        width={380}
        height={569}
        viewBox="0 0 380 569"
        backgroundColor="#F5F5F5"
        foregroundColor="#EFEFEF"
        style={{width: '100%'}}>
        <rect x="20" y="30" rx="0" ry="0" width="206" height="32" />
        <rect x="20" y="68" rx="0" ry="0" width="335" height="32" />
        <rect x="0" y="120" rx="0" ry="0" width="190" height="224" />
        <rect x="191" y="120" rx="0" ry="0" width="190" height="224" />
        <rect x="0" y="345" rx="0" ry="0" width="190" height="224" />
        <rect x="191" y="345" rx="0" ry="0" width="190" height="224" />
      </ContentLoader>
    </div>
  );
}
